import { Field, FormArray, FormGroup, GenericComponent, PInput } from "../../models/models";
import * as Yup from "yup";

export function getInitalValuesAndValidationSchema(FormBody: FormGroup): [any, Yup.ObjectSchema<any>] {
  let [model, yup] = createInitialValues({}, {}, FormBody.fields, true);

  if (FormBody.key != null) {
    model = { [FormBody.key]: model };
    yup = Yup.object({ [FormBody.key]: yup });
  }
  return [model, yup];
}
export function createInitialValues(
  currModel: any,
  currYup: any,
  currFields: (Field | FormGroup | FormArray | PInput | GenericComponent)[],
  doYup: boolean
): [any, Yup.ObjectSchema<any>] {
  currFields.forEach((f) => {
    switch (f.type) {
      case "field":
        {
          currModel[f.key] = getInitialValueForField(f);
          if (f.validation) {
            currYup[f.key] = f.validation;
            currYup[f.key] = getValidationForField(f).when(f.key + "Hidden", {
              is: false,
              then: () => f.validation,
              otherwise: () => Yup.mixed().notRequired(),
            } as any);
            currModel[f.key + "Hidden"] = false;
            currYup[f.key + "Hidden"] = Yup.boolean().notRequired();
          }
        }
        break;

      case "formGroup":
        {
          if (f.key != null) {
            const res = createInitialValues({}, {}, f.fields, true);
            currModel[f.key] = res[0];
            if (f.hideExpression != null) {
              currModel[f.key + "Hidden"] = false;
              currYup[f.key + "Hidden"] = Yup.boolean().notRequired();
              currYup[f.key] = lazyHiddenSchema(f.key + "Hidden", res[1]);

              if (f.test) {
                //fake field to attach error message without overriding inner object errrors
                currModel[f.key + "Test"] = false;
                //use when to get the actual object value instead of bool to pass into test
                const test = Yup.bool().when([f.key], ([objValues]) => {
                  return Yup.bool().test(f.test![0], f.test![1], () => f.test![2](objValues));
                });
                currYup[f.key + "Test"] = lazyHiddenSchema(f.key + "Hidden", test);
              }
            } else {
              currYup[f.key] = res[1];
              if (f.test) {
                currModel[f.key + "Test"] = false;
                currYup[f.key + "Test"] = Yup.bool().when([f.key], ([objValues]) => {
                  return Yup.bool().test(f.test![0], f.test![1], () => f.test![2](objValues));
                });
              }
            }
          } else {
            createInitialValues(currModel, currYup, f.fields, false);
          }
        }
        break;

      case "formArray":
        {
          const res = createInitialValues({}, {}, f.fields, true);
          currModel[f.key] = [res[0]];
          f.childModel = res[0];
          currYup[f.key] = Yup.array().of(res[1]);
        }
        break;
    }
  });
  //if FieldGroup is its own object make Yup.object, else return to higher level
  if (doYup) currYup = Yup.object(currYup);
  return [currModel, currYup];
}

export function getInitialValueForField(field: Field): any {
  switch (field.fieldType) {
    case "input":
      return field.defaultValue ?? "";

    case "textarea":
      return field.defaultValue ?? "";

    case "calendar":
      return field.defaultValue ?? null;

    case "checkbox":
      return field.defaultValue ?? false;

    case "datatable":
      return field.defaultValue ?? [];

    case "dropdown":
      return field.defaultValue ?? null;

    case "radio":
      return field.defaultValue ?? null;

    case "editor":
      return field.defaultValue ?? "";

    case "file":
      return field.defaultValue ?? { files: [] };

    case "number":
      return field.defaultValue ?? null;

    case "search":
      return field.defaultValue ?? null;
    case "error":
      return true;
    default:
      return null;
  }
}

function getValidationForField(field: Field): Yup.Schema<any> {
  switch (field.fieldType) {
    case "input":
      return Yup.string();
      break;

    case "textarea":
      return Yup.string();
      break;

    case "calendar":
      return Yup.date();
      break;

    case "checkbox":
      return Yup.boolean();
      break;

    case "datatable":
      return Yup.array();
      break;

    case "dropdown":
      return Yup.mixed(); // You can adjust this based on your dropdown's type
      break;

    case "radio":
      return Yup.mixed(); // You can adjust this based on your dropdown's type
      break;

    case "editor":
      return Yup.string();
      break;

    case "file":
      return Yup.object().shape({
        files: Yup.array(),
      });
      break;

    case "search":
      return Yup.string();
      break;

    case "number":
      return Yup.number();
      break;

    default:
      return Yup.mixed(); // Default case for unsupported field types
      break;
  }
}

function lazyHiddenSchema(hiddenKey: string, schema: Yup.Schema) {
  return Yup.lazy((_, { parent }) => {
    if (parent?.[hiddenKey]) {
      return Yup.mixed().notRequired();
    } else {
      return schema;
    }
  });
}
